<template>
  <div id="the-footer" class="container-fluid bg-img-green">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-md-8 offset-md-2">
          <div id="items-footer" class="row">
            <div class="col text-white text-center">
              <p>
                <a
                  class="text-white text-center"
                  href="https://www.solera.com/"
                  style="text-decoration: none"
                >
                  TotalCheck a Solera company
                </a>
              </p>
            </div>
            <div class="col text-center">
              <a
                href="mailto:info@totalcheck.mx"
                class="text-white"
                tabindex="-1"
              >
                <p>info@totalcheck.mx</p>
              </a>
            </div>
            <div class="col text-white text-center">
              <a
                href="https://totalcheck.mx/app/aviso"
                target="_blank"
                class="text-white"
                tabindex="-1"
              >
                <p>Términos y condiciones</p>
              </a>
            </div>
            <div class="col text-white text-center">
              <a
                class="text-white"
                href="https://totalcheck.mx/app/images/guia_rapida_de_uso.pdf"
                target="_blank"
                tabindex="-1"
              >
                <p>Guía rápida de uso</p>
              </a>
            </div>
            <div
              class="col text-center d-flex flex-row-reverse bd-highlight justify-content-between"
            >
              <div class="p-2 bd-highlight text-center">
                <a
                  href="https://www.facebook.com/totalcheckmx"
                  target="_blank"
                  class="social-icon-anchor"
                  tabindex="-1"
                  @click="facebookClick"
                >
                  <font-awesome-icon
                    :icon="['fab', 'facebook-f']"
                    size="2x"
                    :style="{ color: 'white' }"
                  />
                </a>
              </div>
              <div class="p-2 bd-highlight text-center">
                <a
                  href="https://twitter.com/totalcheckmx"
                  target="_blank"
                  class="social-icon-anchor"
                  tabindex="-1"
                  @click="twitterClick"
                >
                  <font-awesome-icon
                    :icon="['fab', 'twitter']"
                    size="2x"
                    :style="{ color: 'white' }"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="secondary" />
      <div class="col-md-8 offset-md-2 footer-border" />
      <div class="row" style="padding-top: 20px">
        <div class="col-md-8 offset-md-2">
          <div class="col-sm-12 text-white text-center">
            <p>Auto Apps de México S. de R.L. de C.V.</p>
            <p>Disponible solo en México</p>
          </div>
          <div class="col-sm-12 text-white text-center">
            <p>
              Av Rio Churubusco 601, Xoco, Benito Juarez, 03330 Ciudad de México
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Footer -->
</template>
<script>
export default {
  name: "TheFooter",
  components: {},
  methods: {
    facebookClick: function () {
      this.$ga.event("Interaction", "click_facebook_b2c", "home_b2c");
    },
    twitterClick: function () {
      this.$ga.event("Interaction", "click_twitter_b2c", "home_b2c");
    },
  },
};
</script>
